document.addEventListener('DOMContentLoaded', function(){

  // placeholder
  setPlaceHolder();

  // inputNumOnly（inputChange()）
  inputNumOnly('js-inputChange');

  // 確認（モーダルウィンドウ）を閉じる
  confirmCloseBtn.addEventListener('click', function(){
    modalCloseExec();
  });

  // 内容を送信する
  submitExecBtn.addEventListener('click', function(){
    history.pushState( null, null, '/index.php' );
    document.forms[0].submit();
  });

});



// 確認（モーダルウィンドウ）を閉じるボタン
const confirmCloseBtn = document.getElementById('confirmCloseBtn');

// 内容を送信するボタン
const submitExecBtn = document.getElementById('submitExecBtn');


// body に付与する確認（モーダルウィンドウ）を表示するクラス名
const modalOpenClass = 'confirm-open';

// 確認（モーダルウィンドウ）の要素（内容を書き換える要素）
const modalWindowContents = document.getElementById('modalWindowContents');



/**
***  モーダルウインドウを開く  */
function modalOpenExec( contents )
{
  document.body.classList.add(modalOpenClass);
  modalWindowContents.innerHTML = contents;
}

/**
***  モーダルウインドウを閉じる  */
function modalCloseExec()
{
  document.body.classList.remove(modalOpenClass);
  modalWindowContents.innerHTML = '';
}


/**
***  placeholder  */
function setPlaceHolder()
{
  const placeholderParent = document.querySelectorAll('.placeholder-parent');
  const focusClass = {
    in: 'focus-in',
    fixed: 'focus-fixed'
  }
  for ( let i = 0; i < placeholderParent.length; i++ ) {
    const child = placeholderParent[i].firstElementChild; //最初の子要素

    child.addEventListener('focus', function(event) {
      placeholderParent[i].classList.add(focusClass.in);
    });
    child.addEventListener('blur', function(event) {
      placeholderParent[i].classList.remove(focusClass.in);
      placeholderParent[i].classList.remove(focusClass.fixed);
      if( child.value ){
        placeholderParent[i].classList.add(focusClass.fixed);
      }
    });
  }
}



/**
***  inputNumOnly  */
function inputNumOnly(className)
{
  const elements = document.querySelectorAll( '.' + className );

  if( ! elements ){ return }

  elements.forEach( elm => {
    elm.addEventListener('keyup', changeEvt(elm));
    elm.addEventListener('focus', changeEvt(elm));
  });

  elements.forEach( elm => {
    elm.addEventListener('change', function(){
      const data = this.value;
      const hankaku = data.replace(/[０-９. ]/g,function(s){
        return String.fromCharCode(s.charCodeAt(0)- 65248);
      });
      this.value = hankaku;
    });
  });

  function changeEvt(e){
    let old = e.value;
    let v, str, othverVal, maxVal2;

    return function(){
      v = e.value;
      str = this.value;
      // 全角数字は半角数字へ変換, 数字以外の文字列は削除
      str = str.replace(/[^0-9 ０-９]+/, '');

      e.addEventListener('blur', function(){
        let str = this.value;
        str = str.replace(/[^0-9 ０-９]+/, '');
        this.value = str;
      });

      if (v !== str){
        e.value = str;
      }

      if ( old != v){
        old = v;
      }
    };
  }
}
